import React, {Component, ErrorInfo, ReactNode} from 'react';

import {exceptionHandler} from './app/apis/error';
import ErrorScreen from './app/components/ErrorScreen';
import { addStateHistory,getStateHistory } from './app/utils/StateHistoryUtil';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    state: State = {
        hasError: false,
    };

    static getDerivedStateFromError(_: Error): State {
        return {hasError: true};
    }

    async componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        addStateHistory('error-caught');
        await exceptionHandler({
            message: error.message,
            name: error.name,
            stack_trace: errorInfo.componentStack || '',
            state_history: getStateHistory(),
        });
    }

    render() {
        if (this.state.hasError) {
            return <ErrorScreen message='There was an error'></ErrorScreen>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
